import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleSymbol = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_14699_166456)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_14699_166456",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 24,
				height: 25,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M23.7695 10.2306H12.2556V14.9428H18.8716C18.7652 15.6097 18.5264 16.2658 18.1767 16.864C17.776 17.5494 17.2807 18.0711 16.7729 18.4685C15.2521 19.6588 13.479 19.9022 12.2476 19.9022C9.13691 19.9022 6.47903 17.8488 5.45011 15.0585C5.40859 14.9573 5.38102 14.8526 5.34745 14.7493C5.12007 14.0391 4.99584 13.287 4.99584 12.5053C4.99584 11.6917 5.13037 10.9129 5.37566 10.1774C6.34319 7.27652 9.06099 5.10983 12.2498 5.10983C12.8912 5.10983 13.5089 5.18781 14.0946 5.34335C15.4333 5.6988 16.3801 6.39886 16.9603 6.95261L20.4613 3.45082C18.3317 1.4565 15.5555 0.248047 12.244 0.248047C9.59665 0.247989 7.1525 1.09045 5.1496 2.51425C3.52531 3.66891 2.19316 5.21485 1.29412 7.01029C0.457891 8.67503 0 10.5199 0 12.5034C0 14.4871 0.458591 16.3511 1.29483 18.0004V18.0116C2.1781 19.7626 3.46975 21.2702 5.0396 22.4196C6.41104 23.4237 8.87017 24.7609 12.244 24.7609C14.1842 24.7609 15.9038 24.4036 17.4203 23.7341C18.5142 23.2511 19.4835 22.6211 20.3611 21.8114C21.5206 20.7416 22.4288 19.4183 23.0486 17.8958C23.6684 16.3733 24 14.6516 24 12.785C24 11.9157 23.9145 11.0329 23.7695 10.2305V10.2306Z",
					fill: "white"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_14699_166456)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter0_f_14699_166456)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M-0.175781 12.5859C-0.163055 14.5383 0.381619 16.5526 1.20607 18.1787V18.1899C1.80178 19.3708 2.61594 20.3037 3.54325 21.2279L9.144 19.1407C8.08437 18.5909 7.92268 18.254 7.1631 17.6393C6.38688 16.8399 5.80836 15.9221 5.44807 14.846H5.43356L5.44807 14.8348C5.21105 14.1242 5.18767 13.3699 5.17892 12.5859H-0.175781Z",
							fill: "url(#paint0_radial_14699_166456)"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter1_f_14699_166456)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M12.2564 0.158203C11.7028 2.14456 11.9145 4.07536 12.2564 5.19878C12.8956 5.19927 13.5115 5.2771 14.0954 5.43215C15.434 5.7876 16.3808 6.48768 16.961 7.04143L20.5515 3.45018C18.4245 1.45824 15.8647 0.161342 12.2564 0.158203Z",
							fill: "url(#paint1_radial_14699_166456)"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter2_f_14699_166456)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M12.2437 0.142578C9.52834 0.142518 7.02145 1.00661 4.96714 2.46696C4.20437 3.00919 3.50439 3.63555 2.8811 4.33208C2.71782 5.89668 4.10342 7.81973 6.84735 7.80382C8.17868 6.22207 10.1477 5.19869 12.3392 5.19869C12.3412 5.19869 12.3432 5.19886 12.3452 5.19887L12.2557 0.142936C12.2516 0.142933 12.2477 0.142578 12.2437 0.142578Z",
							fill: "url(#paint2_radial_14699_166456)"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter3_f_14699_166456)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M21.2066 13.149L18.783 14.8496C18.6766 15.5165 18.4376 16.1725 18.0879 16.7707C17.6873 17.4561 17.1919 17.9779 16.6842 18.3753C15.1665 19.5631 13.3981 19.8077 12.167 19.8087C10.8946 22.0222 10.6715 23.1309 12.2565 24.9174C14.2178 24.9159 15.9566 24.5543 17.4903 23.8772C18.599 23.3877 19.5812 22.7492 20.4706 21.9287C21.6457 20.8445 22.5661 19.5034 23.1943 17.9605C23.8224 16.4176 24.1583 14.6729 24.1583 12.7812L21.2066 13.149Z",
							fill: "url(#paint3_radial_14699_166456)"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter4_f_14699_166456)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M12.0771 10.0488V15.1191H23.7377C23.8402 14.4247 24.1794 13.5262 24.1794 12.7823C24.1794 11.913 24.094 10.8512 23.949 10.0488H12.0771Z",
							fill: "#3086FF"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter5_f_14699_166456)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M2.93711 4.15234C2.21753 4.95648 1.60279 5.85654 1.11538 6.82995C0.279159 8.49469 -0.178711 10.5185 -0.178711 12.5021C-0.178711 12.5301 -0.176446 12.5574 -0.176263 12.5853C0.194073 13.3106 4.93926 13.1717 5.17844 12.5853C5.17814 12.5579 5.17512 12.5313 5.17512 12.5038C5.17512 11.6903 5.30969 11.0906 5.55498 10.3551C5.85758 9.44785 6.33138 8.61239 6.93723 7.89257C7.07457 7.71348 7.44091 7.32848 7.54779 7.09755C7.5885 7.00959 7.47388 6.96022 7.46746 6.92926C7.4603 6.89463 7.30661 6.92248 7.27217 6.89668C7.16285 6.81478 6.94637 6.77201 6.81491 6.734C6.53394 6.65274 6.06829 6.47354 5.80965 6.28779C4.9921 5.70062 3.71625 4.99926 2.93711 4.15234Z",
							fill: "url(#paint4_radial_14699_166456)"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter6_f_14699_166456)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M5.82718 6.93289C7.72299 8.10582 8.26818 6.34084 9.52863 5.78854L7.33604 1.14453C6.52949 1.49077 5.76746 1.92094 5.0604 2.42356C4.00449 3.17418 3.07203 4.09015 2.30176 5.13253L5.82718 6.93289Z",
							fill: "url(#paint5_radial_14699_166456)"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter7_f_14699_166456)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M6.59844 18.7807C4.05357 19.719 3.65515 19.7527 3.4209 21.3635C3.86855 21.8097 4.34952 22.2224 4.86062 22.5966C6.23206 23.6007 8.87012 24.938 12.244 24.938C12.2479 24.938 12.2517 24.9376 12.2557 24.9376V19.721C12.2531 19.7211 12.2502 19.7212 12.2476 19.7212C10.9842 19.7212 9.97467 19.3823 8.93955 18.7929C8.68433 18.6476 8.2213 19.0378 7.98592 18.8634C7.66128 18.6228 6.88001 19.0707 6.59844 18.7807Z",
							fill: "url(#paint6_radial_14699_166456)"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						opacity: .5,
						filter: "url(#filter8_f_14699_166456)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M10.7656 19.5566V24.8472C11.2377 24.9036 11.729 24.9379 12.2443 24.9379C12.761 24.9379 13.2608 24.9108 13.7464 24.861V19.5923C13.2022 19.6873 12.6896 19.7211 12.248 19.7211C11.7394 19.7211 11.2448 19.6607 10.7656 19.5566Z",
							fill: "url(#paint7_linear_14699_166456)"
						})
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_14699_166456",
				x: -.217854,
				y: 12.5439,
				width: 9.40348,
				height: 8.72672,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: .0210364,
						result: "effect1_foregroundBlur_14699_166456"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_f_14699_166456",
				x: 11.8739,
				y: .11613,
				width: 8.71989,
				height: 6.96696,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: .0210364,
						result: "effect1_foregroundBlur_14699_166456"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_f_14699_166456",
				x: 2.82609,
				y: .100505,
				width: 9.56071,
				height: 7.74625,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: .0210364,
						result: "effect1_foregroundBlur_14699_166456"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_f_14699_166456",
				x: 11.0976,
				y: 12.7392,
				width: 13.1027,
				height: 12.2209,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: .0210364,
						result: "effect1_foregroundBlur_14699_166456"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter4_f_14699_166456",
				x: 12.0351,
				y: 10.0068,
				width: 12.1867,
				height: 5.15446,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: .0210364,
						result: "effect1_foregroundBlur_14699_166456"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter5_f_14699_166456",
				x: -.220784,
				y: 4.11027,
				width: 7.8195,
				height: 9.00993,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: .0210364,
						result: "effect1_foregroundBlur_14699_166456"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter6_f_14699_166456",
				x: 2.00597,
				y: .848742,
				width: 7.81814,
				height: 6.77322,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: .147894,
						result: "effect1_foregroundBlur_14699_166456"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter7_f_14699_166456",
				x: 3.37883,
				y: 18.7177,
				width: 8.91911,
				height: 6.26188,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: .0210364,
						result: "effect1_foregroundBlur_14699_166456"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter8_f_14699_166456",
				x: 10.7236,
				y: 19.5146,
				width: 3.06461,
				height: 5.465,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: .0210364,
						result: "effect1_foregroundBlur_14699_166456"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_14699_166456",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(9.03188 21.044) rotate(-92.3395) scale(12.2175 17.9461)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .141612,
						stopColor: "#1ABD4D"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .247515,
						stopColor: "#6EC30D"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .311547,
						stopColor: "#8AC502"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .366013,
						stopColor: "#A2C600"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .445673,
						stopColor: "#C8C903"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .540305,
						stopColor: "#EBCB03"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .615636,
						stopColor: "#F7CD07"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .699345,
						stopColor: "#FDCD04"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .771242,
						stopColor: "#FDCE05"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .860566,
						stopColor: "#FFCE0A"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_14699_166456",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(20.2156 6.78158) scale(8.46967 10.9381)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .408458,
					stopColor: "#FB4E5A"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF4540"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint2_radial_14699_166456",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(15.5896 -1.44075) rotate(151.02) scale(13.5652 18.4078)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .231273,
						stopColor: "#FF4541"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .311547,
						stopColor: "#FF4540"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .457516,
						stopColor: "#FF4640"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .540305,
						stopColor: "#FF473F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .699346,
						stopColor: "#FF5138"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .771242,
						stopColor: "#FF5B33"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .860566,
						stopColor: "#FF6C29"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FF8C18"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_14699_166456",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(12.433 23.3309) rotate(-127.454) scale(35.3881 13.0626)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .131546,
						stopColor: "#0CBA65"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .209784,
						stopColor: "#0BB86D"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .297297,
						stopColor: "#09B479"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .396257,
						stopColor: "#08AD93"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .477124,
						stopColor: "#0AA6A9"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .568425,
						stopColor: "#0D9CC6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .667385,
						stopColor: "#1893DD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .768727,
						stopColor: "#258BF1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .858506,
						stopColor: "#3086FF"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint4_radial_14699_166456",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(11.2044 2.457) rotate(96.6178) scale(13.2149 18.2719)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .366013,
						stopColor: "#FF4E3A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .457516,
						stopColor: "#FF8A1B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .540305,
						stopColor: "#FFA312"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .615636,
						stopColor: "#FFB60C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .771242,
						stopColor: "#FFCD0A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .860566,
						stopColor: "#FECF0A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .915033,
						stopColor: "#FECF08"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FDCD01"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint5_radial_14699_166456",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(9.06268 2.321) rotate(132.119) scale(6.56372 18.5132)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .315904,
						stopColor: "#FF4C3C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .603818,
						stopColor: "#FF692C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .726837,
						stopColor: "#FF7825"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .884534,
						stopColor: "#FF8D1B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FF9F13"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint6_radial_14699_166456",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(15.5896 26.4468) rotate(-151.02) scale(13.5652 18.4078)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .231273,
						stopColor: "#0FBC5F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .311547,
						stopColor: "#0FBC5F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .366013,
						stopColor: "#0FBC5E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .457516,
						stopColor: "#0FBC5D"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .540305,
						stopColor: "#12BC58"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .699346,
						stopColor: "#28BF3C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .771242,
						stopColor: "#38C02B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .860566,
						stopColor: "#52C218"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .915033,
						stopColor: "#67C30F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#86C504"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_14699_166456",
				x1: 10.7656,
				y1: 22.2473,
				x2: 13.7464,
				y2: 22.2473,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0FBC5C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0CBA65"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_14699_166456",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 24,
					height: 24.5129,
					fill: "white",
					transform: "translate(0 0.244141)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgGoogleSymbol);
export { ForwardRef as ReactComponent };
